export const MESSAGE_TYPE = {
    show: 'show',
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info'
};

export interface MessageInterface {
    type: string;
    title?: string;
    message: string;
}
